import { render, staticRenderFns } from "./FileConfigDialog.vue?vue&type=template&id=6d7e5fb2&scoped=true"
import script from "./FileConfigDialog.vue?vue&type=script&lang=js"
export * from "./FileConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./FileConfigDialog.vue?vue&type=style&index=0&id=6d7e5fb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7e5fb2",
  null
  
)

export default component.exports